// extracted by mini-css-extract-plugin
module.exports = {"partnersListTitle":"ea57j","partnersList":"Yq1MQ","partnersCustomScrollbar":"w8wl1"};